import "./Statistics.css"
import Analytics from "../statistics-component/Analytics";
import Charts from "../statistics-component/Charts";
import { UsePermissions, hasPermissions } from "../../../general/general-component/abstruct-component/UsePermissions";
import CheckPermissions from "../../../general/general-component/check-permissions";
import CheckLazyLoader from "../../../general/general-component/check-lazy-loader";

const Statistics = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const dashboard = hasPermissions([{ name: "dashboard" }], permissionss);
    return (
        <>
            <CheckLazyLoader>
                <CheckPermissions statistics array={dashboard} loadingMainPermission={loadingMainPermission} >
                    <main style={{ position: "relative" }} >
                        <Analytics />
                        {/*<Charts />*/}
                    </main>
                </CheckPermissions>
            </CheckLazyLoader>
        </>
    )
}

export default Statistics;